import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Paper)`
  width: 45rem;
  height: ${({ height }) => height || '20rem'};
  overflow: auto;

  .MuiListItem-dense {
    padding: 0;
  }

  .MuiListItemIcon-root {
    min-width: 33px;
  }

  .PrivateSwitchBase-root-23,
  .MuiListItem-dense {
    padding: 2px;
  }
`;

export const WrapperInput = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 1rem;

  p {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  input {
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

export const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 45rem;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }
`;
